import React, { Component } from 'react';
import axios from 'axios';


class AddVideo extends Component {
  state = {
    title: '',
    selectedImage: null,
    selectedMainImage: null,
    selectedVideo: null,
    selectedMainVideo: null,
    isActive: false,
    windowHeight: window.innerHeight - 60,
    error: null,
    loading: false, // Added loading state
  };
  // for the image 
  fileInputRef = React.createRef();
  fileInputRefs = React.createRef();







  


  // start of the handle submition


  handleInputChange = (event) => {
    const { name, value } = event.target;
      this.setState({ [name]: value });
    }

 
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    const formData = new FormData();
    formData.append('title', this.state.title);
    if (this.state.selectedMainVideo) {
      formData.append('file_path', this.state.selectedMainVideo);
    }
    if (this.state.selectedMainImage) {
      formData.append('thumbnail', this.state.selectedMainImage);
    }


    try {
      const course_id = this.props.course_id
      const courseId = parseInt(course_id, 10);
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/videos/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.setState({
        title: '',
        selectedImage: null,
        selectedMainImage: null,
        selectedVideo: null,
        selectedMainVideo: null,
      });
      if (this.props.onDocumentSubmit) {  // Check if the prop exists
        this.props.onDocumentSubmit(); // Call the callback to signal the parent
      }
    } catch (error) {
      console.error('Error submitting form:', error);

    }
    finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };


  // end for the submition





  
  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({selectedMainVideo: event.target.files[0] });

    if (file && file.type.startsWith('video/')) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.setState({ selectedVideo: e.target.result });
      };
      reader.readAsDataURL(file);
    }
  };
  handleFileChanges = (event) => {
    const file = event.target.files[0];
    this.setState({ selectedMainImage: file }); // Store the File object

    if (file && file.type.startsWith('image/')) { // Corrected file type check
        const reader = new FileReader();

        reader.onload = (e) => {
            this.setState({ selectedImage: e.target.result }); // Keep selectedImage for preview
        };
        reader.readAsDataURL(file);
    }
};

  handleDragOver = (event) => {
    event.preventDefault();
  };

  handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    this.handleFileChange({ target: { files: [file] } });
  };
  handleDrops = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    this.handleFileChanges({ target: { files: [file] } });
  };

  handleButtonClick = (e) => {
    e.preventDefault()
    this.fileInputRef.current.click();
  };
  handleButtonClicks = (e) => {
    e.preventDefault()
    this.fileInputRefs.current.click();
  };

  handleCancelImage = (e) => {
    e.preventDefault()
    this.setState({ selectedVideo: null });
    
  };
  handleCancelImages = (e) => {
    e.preventDefault()
    this.setState({ selectedImage: null });
    
  };
  // end of the image




  // the display
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover.addvideo")
      formdisplay.style.display = "none"
    }

  };
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  render() {
    const { selectedVideo, selectedImage } = this.state;
    const { menuCoverWidth } = this.state;

    return (

      <div className="dash_add_course_cover addvideo" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Add Video</h2>
          <p>Make sure to follow the instruction if any bellow the input </p>
          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label htmlFor="title">Title</label><br />
            <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="Input course title" /><br /><br />

            <label htmlFor="video">Upload Thumbnail</label><br />
            <div className="video-uploader">
              <div className="drop-zone"
                onDragOver={this.handleDragOver}
                onDrop={this.handleDrops}>
                {selectedImage ? (
                  <div className="video-preview">
                    {/* You can display a video preview here, e.g., using a video tag */}
                    <img src={selectedImage} alt='selected' /> 
                    <button onClick={this.handleCancelImages}>Cancel</button>
                  </div>
                ) : (
                  <div className="drop-zone-text">
                    Drag and drop a image here<br />
                    or <button onClick={this.handleButtonClicks}>Click to select</button>
                  </div>
                )}
              </div>
              <input
                type="file"
                id='image'
                accept="image/*"
                onChange={this.handleFileChanges}
                ref={this.fileInputRefs}
                style={{ display: 'none' }}
              />
            </div><br /><br />
            



            <label htmlFor="video">Upload Video</label><br />
            <div className="video-uploader">
              <div className="drop-zone"
                onDragOver={this.handleDragOver}
                onDrop={this.handleDrop}>
                {selectedVideo ? (
                  <div className="video-preview">
                    {/* You can display a video preview here, e.g., using a video tag */}
                    <video src={selectedVideo} controls /> 
                    <button onClick={this.handleCancelImage}>Cancel</button>
                  </div>
                ) : (
                  <div className="drop-zone-text">
                    Drag and drop a video here<br />
                    or <button onClick={this.handleButtonClick}>Click to select</button>
                  </div>
                )}
              </div>
              <input
                type="file"
                id='video'
                accept="video/*"
                onChange={this.handleFileChange}
                ref={this.fileInputRef}
                style={{ display: 'none' }}
              />
            </div><br /><br />


           
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Uploading..." : "Submit"}
            </button>
          </form>
        </div>
      </div>


    );
  }
}

export default AddVideo;